module.exports = __webpack_public_path__ + "static/media/hahnemuhle-metallic-pearl.8e5c10de.jpg";